// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-banner[data-v-541e8b4e]{background:var(--g-color-dark-green);color:#fff;overflow:hidden}.text-banner .grid[data-v-541e8b4e]{padding-bottom:2rem;padding-top:3rem}.text-banner h1[data-v-541e8b4e]{margin:0 0 .625rem}.text-banner p[data-v-541e8b4e]{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
